import axios from "axios";
import Configurator from "../../config/Configurator";

/**
 * Builds a URL for the license key proposal endpoint with optional query parameters.
 * @param {boolean} expiryEnabled - Whether to include the expiry date parameter
 * @param {string} expiryValue - Expiry date as ISO string (e.g., "2026-07-20")
 * @param {boolean} usersLimitEnabled - Whether to include the user limit parameter
 * @param {number} usersLimitValue - Maximum number of users allowed
 * @param {object} userExpiryList - List of users with custom expiry date
 */
export async function setSubmission(submission) {
  try {
    const url = (await Configurator()).API_URL + "/license_key/submission";

    const res = await axios.request({
      method: "post",
      url,
      headers: {
        Session: localStorage.getItem("apiKey"),
        "User-Id": localStorage.getItem("userID"),
        "Content-Type": "application/json",
      },
      data: submission,
      validateStatus: () => true,
    });

    const ok = res.status >= 200 && res.status < 300

    if (!ok) {
      return {
        success: false,
        message: res.data?.status?.errDesc || "Failed to fetch proposal",
        raw: res.data
      };
    }
    return { success: true, raw: res.data };
  } catch (err) {
    console.error("proposal error:", err);
    return { success: false, message: "Network error" };
  }
}
